import React from "react";
// import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import IconBox from "../../components/common/IconBox/IconBox";
import MainButton from "../../components/common/MainButton/MainButton";
// import cctv from "../../assets/img/cctv.svg";
import { businessCategories } from "./BusinessCategories";
import Heading from "../../components/common/Typography/Heading";
import {
  PUBLIC_HOME_HERO_TO_SECTION_CLASS,
  PUBLIC_HEADING_TO_CONTENT_CLASS,
  PUBLIC_CONTENT_TO_CTA_CLASS,
  PUBLIC_HOME_CATEGORY_GRID_CLASS,
  PUBLIC_HOME_CATEGORY_GRID_GAP_CLASS,
  PUBLIC_ICON_TO_TEXT_CLASS,
} from "../Public/shared/publicLayoutSpec";
// import { motion, useInView } from "framer-motion";
// import { useRef } from "react";

const COLS = 6; // grid columns on xl
const INITIAL_ROWS = 7;

const Services = () => {
  // const businessCategories = useSelector(
  //   (category) => category.BusinessCategoryReducer
  // );
  const sortedLatestData = businessCategories.sort((a, b) => {
    if (a.businessCategoryName < b.businessCategoryName) return -1;
    if (a.businessCategoryName > b.businessCategoryName) return 1;
    return 0;
  });
  const categoriesExcludingOthers = sortedLatestData?.filter(
    (e) => e.businessCategoryName !== "Others"
  ) ?? [];
  const totalCount = categoriesExcludingOthers.length;
  const initialVisible = INITIAL_ROWS * COLS; // 7 rows
  const [LoadMoreImagesIncrement, setLoadMoreImagesIncrement] =
    React.useState(initialVisible);

  // Ref for heading
  // const headingRef = useRef(null);
  // const isHeadingInView = useInView(headingRef, { once: true, amount: 1 });

  // Ref for grid container
  // const gridRef = useRef(null);
  // const isGridInView = useInView(gridRef, { once: true, amount: 0.3 });

  return (
    <>
      <div
        id="categorie"
        className={`tp-container-home mx-auto ${PUBLIC_HOME_HERO_TO_SECTION_CLASS}`}
      >
        <div>
          {/* <motion.div
            ref={headingRef}
            initial={{ opacity: 0, y: 40 }}
            animate={isHeadingInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 40 }}
            transition={{ duration: 1, ease: "easeOut" }}
          > */}
            <Heading variant={"h2"} className={"text-offblack text-start"}>
              Click, Choose, Connect
            </Heading>
          {/* </motion.div> */}
        </div>
        {/* <div className="flex justify-center w-full "> */}
        <div 
          className={`${PUBLIC_HOME_CATEGORY_GRID_CLASS} ${PUBLIC_HOME_CATEGORY_GRID_GAP_CLASS} ${PUBLIC_HEADING_TO_CONTENT_CLASS}`}
        >
          {categoriesExcludingOthers
            ?.slice(0, LoadMoreImagesIncrement)
            ?.map((e, index) => {
              return (
                <div
                  key={index}
                >
                  <Link to={`/category/${e.slug}`}>
                    <IconBox
                      id={e?.id}
                      iconToTextClassName={PUBLIC_ICON_TO_TEXT_CLASS}
                      // className={e?.className}
                      imgclassName={
                        "cursor-pointer mx-auto size-[40px] lg:size-[45px] xl:size-[50px]"
                      }
                      // imgclassName={e.imgclassName}
                      // textclassName={e?.textclassName}
                      image={e?.categoryImage}
                      Alt={e?.businessCategoryName + "icon"}
                      // image={cctv}
                      text={
                        e.businessCategoryName.includes("&") ? (
                          <React.Fragment>
                            {e.businessCategoryName.split("&")[0]}
                            <br />& {e.businessCategoryName.split("&")[1]}
                          </React.Fragment>
                        ) : e.businessCategoryName.split(" ").length === 2 &&
                          e.businessCategoryName.split(" ")[0].length > 3 ? (
                          <React.Fragment>
                            {e.businessCategoryName.split(" ")[0]}
                            <br />
                            {e.businessCategoryName.split(" ")[1]}
                          </React.Fragment>
                        ) : (
                          e.businessCategoryName
                        )
                      }
                      // text={e?.businessCategoryName.split('&').join("<br/>")}
                      direction={"horizontal"}
                    />
                  </Link>
                </div>
              );
            })}
          {businessCategories
            ?.filter((e) => e.businessCategoryName === "Others")
            ?.map((e, index) => {
              let img = JSON.parse(e?.categoryImage);
              return (
                <IconBox
                  key={index}
                  iconToTextClassName={PUBLIC_ICON_TO_TEXT_CLASS}
                  image={img}
                  text={e?.businessCategoryName}
                  direction={"horizontal"}
                />
              );
            })}
        </div>

        <div className={`flex justify-center ${PUBLIC_CONTENT_TO_CTA_CLASS}`}>
          {LoadMoreImagesIncrement < totalCount && (
            <MainButton
              variant={"medium"}
              onClick={() => {
                setLoadMoreImagesIncrement(totalCount);
              }}
            >
              Load more
            </MainButton>
          )}
        </div>
      </div>
    </>
  );
};

export default Services;